import React from 'react';

// Half-circle speedometer showing income vs ceiling (4x cap)
export const Speedometer = ({ percent = 0, current = '0', ceiling = '0', label = 'Ceiling' }) => {
  const p = Math.min(100, Math.max(0, percent));
  // arc: 180° sweep from left to right; radius 90, cx 110, cy 110
  const radius = 90;
  const cx = 110;
  const cy = 110;
  const circumference = Math.PI * radius; // half-circle length
  const dashArray = circumference;
  const dashOffset = circumference * (1 - p / 100);

  return (
    <div className="speedometer-wrap">
      <div className="speedometer">
        <svg viewBox="0 0 220 130" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="speedGrad" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#00e5ff" />
              <stop offset="50%" stopColor="#a855ff" />
              <stop offset="100%" stopColor="#ff2d92" />
            </linearGradient>
          </defs>
          {/* track */}
          <path
            d={`M ${cx - radius} ${cy} A ${radius} ${radius} 0 0 1 ${cx + radius} ${cy}`}
            stroke="#1c1c40"
            strokeWidth="14"
            fill="none"
            strokeLinecap="round"
          />
          {/* fill */}
          <path
            d={`M ${cx - radius} ${cy} A ${radius} ${radius} 0 0 1 ${cx + radius} ${cy}`}
            stroke="url(#speedGrad)"
            strokeWidth="14"
            fill="none"
            strokeLinecap="round"
            strokeDasharray={dashArray}
            strokeDashoffset={dashOffset}
            style={{ transition: 'stroke-dashoffset 1.2s cubic-bezier(0.16, 1, 0.3, 1)' }}
          />
          {/* tick marks */}
          {[0, 25, 50, 75, 100].map((tick) => {
            const angle = Math.PI * (1 - tick / 100);
            const x1 = cx + Math.cos(angle) * (radius - 12);
            const y1 = cy - Math.sin(angle) * (radius - 12);
            const x2 = cx + Math.cos(angle) * (radius - 4);
            const y2 = cy - Math.sin(angle) * (radius - 4);
            return <line key={tick} x1={x1} y1={y1} x2={x2} y2={y2} stroke="#4a4d68" strokeWidth="1.5" />;
          })}
        </svg>
        <div className="center-value">
          <div className="big">{p.toFixed(1)}%</div>
          <div className="small">{label}</div>
        </div>
      </div>
      <div className="speedometer-legend">
        <div className="item">
          <div className="lbl">Received</div>
          <div className="val" style={{ color: 'var(--neon-cyan)' }}>${current}</div>
        </div>
        <div className="item">
          <div className="lbl">Ceiling (4x)</div>
          <div className="val" style={{ color: 'var(--neon-pink)' }}>${ceiling}</div>
        </div>
      </div>
    </div>
  );
};
